// Wire jQuery AJAX to automatically send Django's CSRF cookie as a header
// on every state-changing request. Also tags requests with
// X-Requested-With so views can distinguish AJAX from form posts.
//
// Django sets the `csrftoken` cookie when any rendered page includes a
// {% csrf_token %} tag — _master.html does this in a hidden form.

(function ($) {
  'use strict';

  function getCookie(name) {
    var match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return match ? decodeURIComponent(match.pop()) : '';
  }
  window.getCsrfToken = function () { return getCookie('csrftoken'); };

  $.ajaxSetup({
    beforeSend: function (xhr, settings) {
      if (!/^(GET|HEAD|OPTIONS|TRACE)$/i.test(settings.type)) {
        xhr.setRequestHeader('X-CSRFToken', getCookie('csrftoken'));
      }
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
  });
})(jQuery);
